module.exports = __webpack_public_path__ + "static/media/EmergencyItemsIcon.d864c883.svg";